import request from './request'

export function listOperation(data) {
  return request.post('/mes/operations/list', data)
}
export function selectOperation() {
  return request.get('/mes/operations/select')
}
export function getOperation(id) {
  return request.get('/mes/operations/' + id)
}
export function getOperationGuide(id) {
  return request.get('/mes/operations/' + id + '/guide')
}
export function saveOperation(data) {
  return request.post('/mes/operations', data)
}
export function updateOperation(data) {
  return request.post('/mes/operations/update', data)
}
export function deleteOperation(ids) {
  return request.post('/mes/operations/delete', ids)
}
